import API from "../../../global/api";

export const requestAdditionalForms = (data) => {
  return {
    type: "REQUEST_ADDITIONAL_FORMS",
  };
};
export const successAdditionalForms = (data) => {
  return {
    type: "SUCCESS_ADDITIONAL_FORMS",
    payload: data,
  };
};
export const errorAdditionalForms = (data) => {
  return {
    type: "ERROR_ADDITIONAL_FORMS",
    payload: data,
  };
};

export const getAdditionalForms = () => {
  return (dispatch) => {
    API.get(`/petitional/get-forms`, {
      headers: {
        /*Authorization: `Bearer ${window.localStorage.getItem("auth_id")}`,*/
      },
    }).then((res) => {
      let data = [];
      data = res.data;
      dispatch(successAdditionalForms(data));
    });
  };
};

export const requestFormData = () => {
  return {
    type: "REQUEST_FORM_DATA",
  };
};
export const successFormData = (data) => {
  return {
    type: "SUCCESS_FORM_DATA",
    payload: data,
  };
};
export const errorFormData = () => {
  return {
    type: "ERROR_FORM_DATA",
  };
};

export const getFormData = () => {
  return (dispatch) => {
     dispatch(requestFormData());
    API.post(`/petitional/get-all-form-data`,{
      divorce_id: window.localStorage.getItem("divorce_id"),
    }).then((res) => {
      let data = [];
      data = res.data;
      dispatch(successFormData(data));
    }).catch((error)=> 
    dispatch(errorFormData()));
  };
};

//CHILD CUSTODY RIGHTS

export const putChildCustodyRights = (data) => {
  return (dispatch) => {
    API.put(`/petitional/child_custody_right`, data).then((res) => {
      dispatch(successputChildCustodyRights(data));
    });
  };
};

export const requestputChildCustodyRights = () => {
  return {
    type: "REQUEST_CHILD_CUSTODY_RIGHT",
  };
};
export const successputChildCustodyRights = (data) => {
  return {
    type: "SUCCESS_CHILD_CUSTODY_RIGHT",
    payload: data,
  };
};
export const errorputChildCustodyRights = (data) => {
  return {
    type: "ERROR_CHILD_CUSTODY_RIGHT",
    payload: data,
  };
};

//COMMUNITY PROPERTY

export const putCommunityProperty = (data) => {
  return (dispatch) => {
    API.put(`/petitional/community_property`, data).then((res) => {
      dispatch(successputCommunityProperty(data));
    });
  };
};

export const requestputCommunityProperty = (data) => {
  return {
    type: "REQUEST_COMMUNITY_PROPERTY",
  };
};
export const successputCommunityProperty = (data) => {
  return {
    type: "SUCCESS_COMMUNITY_PROPERTY",
    payload: data,
  };
};
export const errorputCommunityProperty = (data) => {
  return {
    type: "ERROR_COMMUNITY_PROPERTY",
    payload: data,
  };
};

//Separate Property
export const putSeparateProperty = (data) => {
  return (dispatch) => {
    API.put(`/petitional/separate_property`, data).then((res) => {
      dispatch(successputSeparateProperty(data));
    });
  };
};

export const requestputSeparateProperty = (data) => {
  return {
    type: "REQUEST_SEPARATE_PROPERTY",
  };
};
export const successputSeparateProperty = (data) => {
  return {
    type: "SUCCESS_SEPARATE_PROPERTY",
    payload: data,
  };
};
export const errorputSeparateProperty = (data) => {
  return {
    type: "ERROR_SEPARATE_PROPERTY",
    payload: data,
  };
};

//DOMESTIC VOILENCE
export const putDomesticViolence = (data) => {
  return (dispatch) => {
    API.put(`/petitional/domestic_violence`, data).then((res) => {
      dispatch(successputDomesticViolence(data));
    });
  };
};

export const requestputDomesticViolence = (data) => {
  return {
    type: "REQUEST_DOMESTIC_VIOLENCE ",
  };
};
export const successputDomesticViolence = (data) => {
  return {
    type: "SUCCESS_DOMESTIC_VIOLENCE",
    payload: data,
  };
};
export const errorputDomesticViolence = (data) => {
  return {
    type: "ERROR_DOMESTIC_VIOLENCE",
    payload: data,
  };
};

//CUSTODY CASE
export const putChildCustodyCase = (data) => {
  return (dispatch) => {
    API.put(`/petitional/custody_case`, data).then((res) => {
      dispatch(successputChildCustodyCase(data));
    });
  };
};

export const requestputChildCustodyCase = (data) => {
  return {
    type: "REQUEST_CHILD_CUSTODY_CASE ",
  };
};
export const successputChildCustodyCase = (data) => {
  return {
    type: "SUCCESS_CHILD_CUSTODY_CASE",
    payload: data,
  };
};
export const errorputChildCustodyCase = (data) => {
  return {
    type: "ERROR_CHILD_CUSTODY_CASE",
    payload: data,
  };
};

//FilledPetition
export const putFilledPetition = (data) => {
  return (dispatch) => {
    API.put(`/filed_petition/add-filed_petition`, data).then((res) => {
      dispatch(successputFilledPetition(data));
    });
  };
};

export const requestputFilledPetition = (data) => {
  return {
    type: "REQUEST_FILLED_PETITION ",
  };
};
export const successputFilledPetition = (data) => {
  return {
    type: "SUCCESS_FILLED_PETITION",
    payload: data,
  };
};
export const errorputFilledPetition = (data) => {
  return {
    type: "ERROR_FILLED_PETITION",
    payload: data,
  };
};

//isMarried

export const isMarried = (data) => {
  return (dispatch) => {
    API.put(`/petitional/is_married`,data).then((res) => {
      dispatch(successMarriedStatus(data));
    });
  };
};

export const requestMarriedStatus = (data) => {
  return {
    type: "REQUEST_MARRIED_STATUS",
  };
};
export const successMarriedStatus = (data) => {
  return {
    type: "SUCCESS_MARRIED_STATUS",
    payload: data,
  };
};
export const errorMarriedStatus = (data) => {
  return {
    type: "ERROR_MARRIED_STATUS",
    payload: data,
  };
};

//RESIDENCE

export const isResidence = (data) => {
  return (dispatch) => {
    API.put(`/petitional/reside_california`, data).then((res) => {
      dispatch(successResidence(data));
    });
  };
};

export const requestResidence = (data) => {
  return {
    type: "REQUEST_RESIDENCE",
  };
};
export const successResidence = (data) => {
  return {
    type: "SUCCESS_RESIDENCE",
    payload: data,
  };
};
export const errorResidence = (data) => {
  return {
    type: "ERROR_RESIDENCE",
    payload: data,
  };
};

//GET FORMS API CALL

export const getAddForms = () => {
  return (dispatch) => {
    API.get(`/petitional/get-forms`, {
      headers: {
        /*Authorization: `Bearer ${window.localStorage.getItem("auth_id")}`,*/
      },
    }).then((res) => {
      let data = [];
      data = res.data;
      dispatch(successAddForms(data));
    });
  };
};

//ACTION CREATORS
export const requestAddForms = (data) => {
  return {
    type: "REQUEST_ADD_FORMS",
  };
};
export const successAddForms = (data) => {
  return {
    type: "SUCCESS_ADD_FORMS",
    payload: data,
  };
};
export const errorAddForms = (data) => {
  return {
    type: "ERROR_ADD_FORMS",
    payload: data,
  };
};

//ADD SPOUSAL SuPPORT

//API CALLS
export const putAddSppousalSupport = (data) => {
  return (dispatch) => {
    API.put(`/petitional/add-ss`, data).then((res) => {
      dispatch(successAddSppousalSupport(data));
    });
  };
};

//ACTION CREATORS
export const requestAddSppousalSupport = (data) => {
  return {
    type: "REQUEST_ADD_SUPPOUSAL",
  };
};
export const successAddSppousalSupport = (data) => {
  return {
    type: "SUCCESS_ADD_SUPPOUSAL",
    payload: data,
  };
};
export const errorAddSppousalSupport = (data) => {
  return {
    type: "ERROR_ADD_SUPPOUSAL",
    payload: data,
  };
};

//LEGAL,PHYSICAL,VISITATION

//API CALLS

export const putAddCustody = (data) => {
  return (dispatch) => {
    API.put(`/petitional/add-custody`, data).then((res) => {
      dispatch(successAddCustody(data));
    });
  };
};
//ACTION CREATERS

export const requestAddCustody = (data) => {
  return {
    type: "REQUEST_ADD_CUSTODY ",
  };
};
export const successAddCustody = (data) => {
  return {
    type: "SUCCESS_ADD_CUSTODY",
    payload: data,
  };
};
export const errorAddCustody = (data) => {
  return {
    type: "ERROR_ADD_CUSTODY",
    payload: data,
  };
};

//FORMER LAST NAME

//API CALLS
export const putFormerLastName = (data) => {
  return (dispatch) => {
    API.put(`/petitional/update-user`, data).then((res) => {
      dispatch(successFormerLastName(data));
    });
  };
};

//ACTIONS CREATERS
export const requestFormerLastName = (data) => {
  return {
    type: "REQUEST_FORMER_LAST_NAME ",
  };
};
export const successFormerLastName = (data) => {
  return {
    type: "SUCCESS_FORMER_LAST_NAME",
    payload: data,
  };
};
export const errorFormerLastName = (data) => {
  return {
    type: "ERROR_FORMER_LAST_NAME",
    payload: data,
  };
};

//CHILD RESIDENCE

//API CALL
export const putChildResidence = (data) => {
  return (dispatch) => {
    API.put(`/petitional/child-residence`, data).then((res) => {
      dispatch(successChildResidence(data));
    });
  };
};

//ACTIONS CREATORS

export const requestChildResidence = (data) => {
  return {
    type: "REQUEST_CHILD_RESIDENCE ",
  };
};
export const successChildResidence = (data) => {
  return {
    type: "SUCCESS_CHILD_RESIDENCE",
    payload: data,
  };
};
export const errorChildResidence = (data) => {
  return {
    type: "ERROR_CHILD_RESIDENCE",
    payload: data,
  };
};

//CHILD AGE

//API CALL
export const putChildAge = (data) => {
  return (dispatch) => {
    API.put(`/petitional/petitional-childunder18`, data).then((res) => {
      dispatch(successChildAge(data));
    });
  };
};

//ACTIONS
export const requestChildAge = (data) => {
  return {
    type: "REQUEST_CHILD_AGE ",
  };
};
export const successChildAge = (data) => {
  return {
    type: "SUCCESS_CHILD_AGE",
    payload: data,
  };
};
export const errorChildAge = (data) => {
  return {
    type: "ERROR_CHILD_AGE",
    payload: data,
  };
};

//UPDATE DATA
export const putUpdateData = (data) => {
  return (dispatch) => {
    API.put(`/petitional/update-data`, data).then((res) => {
      dispatch(successUpdateData(data));
    });
  };
};

export const requestUpdateData = (data) => {
  return {
    type: "REQUEST_UPDATE_DATA ",
  };
};
export const successUpdateData = (data) => {
  return {
    type: "SUCCESS_UPDATE_DATA",
    payload: data,
  };
};
export const errorUpdateData = (data) => {
  return {
    type: "ERROR_UPDATE_DATA",
    payload: data,
  };
};

//CUSTODY TYPES

export const getCustodyTypes = () => {
  return (dispatch) => {
    API.get(`/petitional/get-custody_type`, {
      headers: {
        /*Authorization: `Bearer ${window.localStorage.getItem("auth_id")}`,*/
      },
    }).then((res) => {
      let data = [];
      data = res.data;
      dispatch(successCustodyTypes(data));
    });
  };
};

//CUSTODY TYPES ACTIONS

export const requestCustodyTypes = (data) => {
  return {
    type: "REQUEST_CUSTODY_TYPES",
  };
};

export const successCustodyTypes = (data) => {
  return {
    type: "SUCCESS_CUSTODY_TYPES",
    paylaod: data,
  };
};

export const errorCustodyTypes = (data) => {
  return {
    type: "ERROR_CUSTODY_TYPES",
    payload: data,
  };
};

//CUSTODY SUBTYPES

export const getCustodySubtypes = () => {
  return (dispatch) => {
    API.get(`/petitional/get-custody_subtype`, {
      headers: {
        /*Authorization: `Bearer ${window.localStorage.getItem("auth_id")}`,*/
      },
    }).then((res) => {
      let data = [];
      data = res.data;
      dispatch(successCustodySubtypes(data));
    });
  };
};

export const requestCustodySubtypes = (data) => {
  return {
    type: "REQUEST_CUSTODY_SUBTYPES",
  };
};

export const successCustodySubtypes = (data) => {
  return {
    type: "SUCCESS_CUSTODY_SUBTYPES",
    paylaod: data,
  };
};

export const errorCustodySubtypes = (data) => {
  return {
    type: "ERROR_CUSTODY_SUBTYPES",
    payload: data,
  };
};

// DOMESTIC PARTNERSHIP

//DP API CALL
export const postDPDetails = (data) => {
  return (dispatch) => {
    API.put(`/petitional/is_dp`, data).then((res) => {
      dispatch(successDomestiPartnership(data));
    });
  };
};

//DP ACTIONS

export const requestDomestiPartnership = (data) => {
  return {
    type: "REQUEST_DOMESTIC_PARTNERSHIP",
  };
};

export const successDomestiPartnership = (data) => {
  return {
    type: "SUCCESS_DOMESTIC_PARTNERSHIP",
    payload: data,
  };
};

export const errorDomestiPartnership = (data) => {
  return {
    type: "ERROR_DOMESTIC_PARTNERSHIP",
    payload: data,
  };
};

export const requestDates = (data) => {
  return {
    type: "REQUEST_DATES ",
  };
};
export const successDates = (data) => {
  return {
    type: "SUCCESS_DATES",
    payload: data,
  };
};
export const errorDates = (data) => {
  return {
    type: "ERROR_DATES",
    payload: data,
  };
};

export const putDates = (data) => {
  return (dispatch) => {
    API.put(`/petitional/marriage-date`, data).then((res) => {
      dispatch(successDates(data));
    });
  };
};

export const getNullity = () => {
  return (dispatch) => {
    API.get(`/petitional/get-nullity_basis`, {
      headers: {
        /*Authorization: `Bearer ${window.localStorage.getItem("auth_id")}`,*/
      },
    }).then((res) => {
      let data = [];
      data = res.data;
      dispatch(successNullity(data));
    });
  };
};

export const requestNullity = (data) => {
  return {
    type: "REQUEST_NULLITY ",
  };
};
export const successNullity = (data) => {
  return {
    type: "SUCCESS_NULLITY",
    payload: data,
  };
};
export const errorNullity = (data) => {
  return {
    type: "ERROR_NULLITY",
    payload: data,
  };
};

///DIVORCE

export const getDivorceLS = () => {
  return (dispatch) => {
    API.get(`/petitional/divorce_ls_basis`, {
      headers: {
        /*Authorization: `Bearer ${window.localStorage.getItem("auth_id")}`,*/
      },
    }).then((res) => {
      let data = [];
      data = res.data;
      dispatch(successDivorceLS(data));
    });
  };
};

export const requestDivorceLS = (data) => {
  return {
    type: "REQUEST_DIVORCE_LS ",
  };
};
export const successDivorceLS = (data) => {
  return {
    type: "SUCCESS_DIVORCE_LS",
    payload: data,
  };
};
export const errorDivorceLS = (data) => {
  return {
    type: "ERROR_DIVORCE_LS",
    payload: data,
  };
};

//FILLING OPTION
export const getFillingOption = () => {
  return (dispatch) => {
    API.get(`/petitional/get-filling_option`, {
      headers: {
        /*Authorization: `Bearer ${window.localStorage.getItem("auth_id")}`,*/
      },
    }).then((res) => {
      let data = [];
      data = res.data;
      dispatch(successFillingOption(data));
    });
  };
};

export const requestFillingOption = (data) => {
  return {
    type: "REQUEST_FILLING_OPTION ",
  };
};
export const successFillingOption = (data) => {
  return {
    type: "SUCCESS_FILLING_OPTION",
    payload: data,
  };
};
export const errorFillingOption = (data) => {
  return {
    type: "ERROR_FILLING",
    payload: data,
  };
};

// Request STATES Actions
export const getStates = () => {
  return (dispatch) => {
    API.get(`/global/get-states`, {
      headers: {
      /*Authorization: `Bearer ${window.localStorage.getItem("auth_id")}`,*/ 
      },
    }).then((res) => {
      let data = [];
      data = res.data;
      dispatch(successStates(data));
    });
  };
};

export const requestStates = (data) => {
  return {
    type: "REQUEST_STATES",
  };
};
export const successStates = (data) => {
  return {
    type: "SUCCESS_STATES",
    payload: data,
  };
};
export const errorStates = (data) => {
  return {
    type: "ERROR_STATES",
    payload: data,
  };
};


export const changeActiveStep = (data) => {
  return {
    type: "CHANGE_ACTIVE_STEP",
    payload: data,
  };
};